var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 31,
    viewBox: "0 0 28 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 18.4177 2.0462 22.3576 5.24256 24.9234L4.5529 29.1511C4.39965 30.0906 5.5216 30.6926 6.21969 30.0455L9.29885 27.1911C10.7682 27.7148 12.3508 28 14 28Z",
    fill: "#FF4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.736 10.97C18.8042 10.9004 18.8857 10.845 18.9756 10.8073C19.0655 10.7695 19.162 10.7501 19.2595 10.7501C19.357 10.7501 19.4535 10.7695 19.5434 10.8073C19.6333 10.845 19.7147 10.9004 19.783 10.97C20.069 11.259 20.073 11.726 19.793 12.02L13.88 19.01C13.8128 19.0837 13.7314 19.143 13.6406 19.1841C13.5497 19.2253 13.4515 19.2475 13.3518 19.2493C13.2521 19.2512 13.1531 19.2327 13.0608 19.195C12.9685 19.1573 12.8848 19.1011 12.815 19.03L9.21698 15.384C9.07822 15.2425 9.00049 15.0522 9.00049 14.854C9.00049 14.6558 9.07822 14.4655 9.21698 14.324C9.28523 14.2544 9.36668 14.199 9.45657 14.1613C9.54646 14.1235 9.64298 14.1041 9.74048 14.1041C9.83798 14.1041 9.9345 14.1235 10.0244 14.1613C10.1143 14.199 10.1957 14.2544 10.264 14.324L13.316 17.417L18.716 10.992L18.736 10.97Z",
    fill: "#FCFFFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckPoint);
export default __webpack_public_path__ + "static/media/CheckPoint.2953633a2c5e827d680652bbddb55cfc.svg";
export { ForwardRef as ReactComponent };